import {
  allVehiclesSelector,
  remoteMonitorConfigAtom,
} from '@data/fms/vehicle/states';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const useCallReceiver = () => {
  const allVehicles = useAtomValue(allVehiclesSelector);
  const remoteMonitorConfig = useAtomValue(remoteMonitorConfigAtom);

  /**
   * 遠隔監視画面を開いている車両は除外
   */
  const excludeCallingVehicles = useMemo(() => {
    if (!remoteMonitorConfig.vehicle) {
      return allVehicles;
    }
    return allVehicles.filter(
      (vehicle) =>
        vehicle.vehicle_id !== remoteMonitorConfig.vehicle?.vehicle_id,
    );
  }, [allVehicles, remoteMonitorConfig]);

  return {
    excludeCallingVehicles,
  };
};
